import React from 'react'

function Footer() {

    return (
        <div className="fixed-bottom footer">
            &copy; {new Date().getFullYear()} Copyright: {"Milad Mosadegh"}
        </div>
    )
}

export default Footer
